import {
  BagCheck,
  Cart,
  JournalText,
  People,
  TicketPerforated,
} from "react-bootstrap-icons";

import Spinner from "react-bootstrap/Spinner";

const AuthenticatingLayout = () => {
  return (
    <>
      <header
        className='navbar sticky-top bg-dark flex-md-nowrap shadow'
        data-bs-theme='dark'
      >
        <a
          className='navbar-brand bg-transparent col-md-3 col-lg-2 me-0 px-3 fs-6 text-white shadow-none'
          href='/'
        >
          {process.env.REACT_APP_MY_APP_NAME}
        </a>
      </header>

      <div className='sidebar border border-right col-md-3 col-lg-2 m-0 p-0 bg-body-tertiary overflow-y-auto'>
        <div
          className='offcanvas-md offcanvas-end bg-body-tertiary'
          tabIndex='-1'
          id='sidebarMenu'
          aria-labelledby='sidebarMenuLabel'
        >
          <div className='offcanvas-header'>
            <h5 className='offcanvas-title' id='sidebarMenuLabel'>
              {process.env.REACT_APP_MY_APP_NAME}
            </h5>
            <button
              type='button'
              className='btn-close'
              data-bs-dismiss='offcanvas'
              data-bs-target='#sidebarMenu'
              aria-label='Close'
            ></button>
          </div>

          <div className='offcanvas-body d-md-flex flex-column p-0 pt-lg-3'>
            <ul className='nav flex-column' id='sideNavigation'>
              <li className='nav-link d-flex align-items-center gap-2 nav-item'>
                <People />
              </li>

              <li className='nav-link d-flex align-items-center gap-2 nav-item'>
                <BagCheck />
              </li>

              <li className='nav-link d-flex align-items-center gap-2 nav-item'>
                <Cart />
              </li>

              <li className='nav-link d-flex align-items-center gap-2 nav-item'>
                <JournalText />
              </li>

              <li className='nav-link d-flex align-items-center gap-2 nav-item'>
                <TicketPerforated />
              </li>
            </ul>
          </div>
        </div>
      </div>

      <main className='col-md-9 ms-sm-auto col-lg-10 mt-3'>
        <Spinner animation='grow' variant='secondary' size='sm' />{" "}
        <Spinner animation='grow' variant='secondary' size='sm' />{" "}
        <Spinner animation='grow' variant='secondary' size='sm' />
      </main>
    </>
  );
};

export default AuthenticatingLayout;
